<template>
  <div class="footerBarBox">
    <div class="publicContent">
      <div class="autoPublicContent" v-if="isPC">
        <div class="footerBarCont">
          <div class="left animate-on-scroll">
            <div class="cont " v-for="(item, index) in menuAll" :key="index"
              v-if="(item.category_component != '/HomePage') && (item.category_component != '/ContactPage')">
              <!-- <div :class="index === 1 ? 'specLeftTop' : index === 4 ? 'specRigthTop' : ''" class=" top " -->
              <div class="top" @click="$router.push(item.category_path)">
                {{ item.category_name }}
              </div>

              <!-- :class="index === 1 ? 'specLeftp' : index === 4 ? 'specRigthp' : index === 2 ? 'specSecondp' : ''" -->
              <p class="animate-on-scroll" v-if="item.children" v-for="(item2, index2) in item.children" :key="index2"
                @click="$router.push(item2.category_path)">{{
                  item2.category_name }}</p>
            </div>
          </div>
          <div class="right" v-if="pageDataArr">
            <!-- <div class="top">联系我们 <span>ontact us</span></div> -->
            <div class="top animate-on-scroll">{{ pageDataArr[6].home_image_title }}</div>
            <div class="cont animate-on-scroll">
              <div class="iconBox"><img src="@/assets/images/footer/position.png"></div>
              <p>{{ pageDataArr[3].home_image_title }}</p>
            </div>

            <div class="cont animate-on-scroll">
              <div class="iconBox"><img src="@/assets/images/footer/phone.png"></div>
              <p>{{ pageDataArr[4].home_image_title }}</p>
            </div>

            <div class="cont animate-on-scroll">
              <div class="iconBox"><img src="@/assets/images/footer/email.png"></div>
              <p>{{ pageDataArr[5].home_image_title }}</p>
            </div>
          </div>
        </div>
        <!-- <div class="copyright" v-if="pageDataArr">
          <p>{{ pageDataArr[10].home_image_title }} <span v-html="pageDataArr[11].home_image_title"></span></p>
        </div> -->
      </div>

      <div class="mBox" v-else>

        <el-collapse v-model="activeNames" accordion>
          <el-collapse-item :title="item.category_name" :name="index" v-for="(item, index) in menuAll" :key="index"
            v-if="(item.category_component != '/HomePage') && (item.category_component != '/ContactPage')">
            <p class="animate-on-scroll" v-if="item.children" v-for="(item2, index2) in item.children" :key="index2"
              @click="$router.push(item2.category_path)" style="color: #fff; padding-left: 20px;">
              <!-- {{ item2.category_path }}
              ---- -->
              {{ item2.category_name }}
            </p>
          </el-collapse-item>
          <!-- 联系我们 -->
          <el-collapse-item title="联系我们">
            <div class="mcontact" v-if="pageDataArr" style="display: flex;flex-direction: column; padding-left: 20px;">
              <div class="cont animate-on-scroll" style="display: flex;align-items: center;text-align: left;">
                <div class="iconBox" style="min-width: 25px; "><img width="100%"
                    src="@/assets/images/footer/position.png"></div>
                <p style="color: #fff;padding-left: 10px;">{{ pageDataArr[3].home_image_title }}</p>
              </div>

              <div class="cont animate-on-scroll" style="display: flex;align-items: center;text-align: left;">
                <div class="iconBox" style="min-width: 25px;"><img width="100%" src="@/assets/images/footer/phone.png">
                </div>
                <p style="color: #fff;padding-left: 10px;">{{ pageDataArr[4].home_image_title }}</p>
              </div>

              <div class="cont animate-on-scroll" style="display: flex;align-items: center;text-align: left;">
                <div class="iconBox" style="min-width: 25px;"><img width="100%" src="@/assets/images/footer/email.png">
                </div>
                <p style="color: #fff; padding-left: 10px;">{{ pageDataArr[5].home_image_title }}</p>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>


      </div>

      <div class="copyright" v-if="pageDataArr">
        <p>{{ pageDataArr[10].home_image_title }} <span v-html="pageDataArr[11].home_image_title"></span></p>
      </div>

    </div>
  </div>
</template>

<script>
// import {mapState} from "vuex"
export default {
  name: 'FooterBar',
  props: {
    pageData: Object
  },
  data() {
    return {
      isPC: this.$commonFn.isPC(),
      activeNames: [],
      observer: null,
      // 2025-11-18 调整为写死
      // menuAll: this.$store.state.menuAll,
      menuAll: [
        {
          category_label: "Home",
          category_path: "/",
          category_component: "/HomePage",
          category_name: "首页",
        },
        {
          category_label: "About",
          category_path: "/About",
          category_component: "/AboutPage",
          category_name: "关于我们",
          children: [
            {
              category_label: "CompanyProfile",
              category_path: "/CompanyProfile",
              category_component: "/AboutPage",
              category_name: "公司简介",
            },
            {
              category_label: "CorporateCulture",
              category_path: "/CorporateCulture",
              category_component: "/AboutPage",
              category_name: "企业文化",
            },
            {
              category_label: "DevelopmentCourse",
              category_path: "/DevelopmentCourse",
              category_component: "/AboutPage",
              category_name: "发展历程",
            },
          ]
        },
        {
          category_label: "Product",
          category_path: "/Product",
          category_component: "/ProductPage",
          category_name: "产品中心",
          children: [
            {
              category_label: "BrandIntroduction",
              category_path: "/BrandIntroduction",
              category_component: "/ProductPage",
              category_name: "品牌介绍",
            },
            {
              category_label: "ProductIntroduction",
              category_path: "/ProductIntroduction",
              category_component: "/ProductPage",
              category_name: "产品介绍",
            },
            {
              category_label: "CustomerIntroduction",
              category_path: "/CustomerIntroduction",
              category_component: "/ProductPage",
              category_name: "客户介绍",
            },
          ]
        },
        {
          category_label: "News",
          category_path: "/News",
          category_component: "/NewsPage",
          category_name: "新闻动态",
          children: [
            {
              category_label: "EnterpriseDynamics",
              category_path: "/EnterpriseDynamics",
              category_component: "/NewsPage",
              category_name: "企业动态",
            },
            {
              category_label: "ProductDynamics",
              category_path: "/ProductDynamics",
              category_component: "/NewsPage",
              category_name: "产品动态",
            },
            {
              category_label: "ActivityDynamics",
              category_path: "/ActivityDynamics",
              category_component: "/NewsPage",
              category_name: "活动动态",
            },
          ]
        }, {
          category_label: "Recruit",
          category_path: "/Recruit",
          category_component: "/RecruitPage",
          category_name: "企业招聘",
          children: [
            {
              category_label: "EmployeeDevelopment",
              category_path: "/EmployeeDevelopment",
              category_component: "/RecruitPage",
              category_name: "员工发展",
            },
            {
              category_label: "WelfareIntroduction",
              category_path: "/WelfareIntroduction",
              category_component: "/RecruitPage",
              category_name: "福利介绍",
            },
            {
              category_label: "Wonderful",
              category_path: "/Wonderful",
              category_component: "/RecruitPage",
              category_name: "劲彩荣祥",
            },
          ]
        }
      ],
      pageDataArr: []
    }
  },
  created() {
    this.pageDataArr = this.pageData.home_image_all

  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect(); // 停止观察并清理资源
    }
  },

  mounted() {

    this.observeElement();
  },

  computed: {
    // ...mapState(['menuAll']),
  },
  methods: {

    // 动画
    observeElement() {
      this.observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate'); // 添加动画类
            observer.unobserve(entry.target); // 停止观察，防止重复触发
            // entry.target.classList.remove('animate');

          }
        });
      }, {
        rootMargin: '0px 0px -50px 0px', // 可选，定义根元素的margin
        threshold: 0.8 // 当目标元素至少有50%进入视口时触发回调
      });

      // 获取所有需要动画效果的元素并观察它们
      const elements = document.querySelectorAll('.animate-on-scroll'); // 修改为你的选择器
      elements.forEach(el => this.observer.observe(el));
    },
  },
  watch: {
    pageData(newValue) {
      // this.pageData = newValue
      this.pageDataArr = newValue.home_image_all
    },
    // '$store.state.menuAll'(newValue) {
    //   this.menuAll = newValue
    // },
  }
}
</script>

<style lang="scss" scoped>
.footerBarBox {

  // 动画
  .animate {
    // animation: slideInUp 1.5s ease-in-out; /*表示动画开始和结束时速度较慢，中间部分较快，整体呈现加速-减速的动态效果*/
    animation: slideInUp 1.5s forwards;
    /*匀速*/
  }

  @keyframes slideInUp {
    from {
      transform: translateY(100%);
      /* 从屏幕底部开始 */
      opacity: 0;
      /* 初始透明度 */
    }

    to {
      transform: translateY(0);
      /* 移动到正常位置 */
      opacity: 1;
      /* 完全不透明 */
    }
  }

  ::v-deep .el-collapse {
    border-top: 0;
  }

  ::v-deep .el-collapse-item__header {
    padding-left: 10px;
    background-color: #000 !important;
    border-bottom: 1px solid #666 !important;
    color: #ffffff !important;
  }

  ::v-deep .el-collapse-item__wrap {
    background-color: #000 !important;
    border-bottom: 0px !important;
  }

  ::v-deep .el-collapse-item__arrow {
    color: #ffffff !important;
  }

  ::v-deep .el-collapse-item__content {
    padding-bottom: 0 !important;
  }

  .publicContent {
    background-color: #212121;
    background: url('@/assets/images/footer-bg.png') repeat;

    .mbox {}

    .footerBarCont {
      padding: 60px 0;
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      p,
      .top {
        margin: 0;
        color: #dddddd;
        text-align: center;
        // text-align: left;
      }

      .left {
        margin-right: 60px;
        flex: 1;
        display: flex;
        flex-direction: row;

        .cont {
          flex: 1;

          .top {
            font-size: clamp(1.5rem, 1.8vw, 2rem);
            color: #efeded;
            font-weight: 500;
            border-bottom: 2px solid #a0a0a0;
            // padding-bottom: 15px;
            margin-bottom: 20px;
            cursor: pointer;
            display: flex;
            height: 4rem;
            align-items: center;
            justify-content: center;
          }

          p {
            margin: 10px 0;
            cursor: pointer;
            color: #a8a8a8;
            font-size: 20px;
            line-height: 40px;
          }

          .specLeftTop {
            justify-content: flex-start;
          }

          .specLeftp {
            text-align: left;
            padding-left: 18px;
          }

          .specRigthTop {
            justify-content: flex-end;
          }

          .specSecondp {
            padding-right: 18px;
          }

          .specRigthp {
            text-align: right;
            padding-right: 18px;
          }

          p:hover,
          .top:hover {
            color: #fff;
          }
        }
      }

      .right {
        max-width: 30%;
        // border-left: 2px solid #a0a0a0;
        padding-left: 30px;
        display: flex;
        flex-direction: column;

        .top {
          font-size: 28px;
          color: #efeded;
          font-weight: 500;
          text-align: left;
          // margin-bottom: 2rem;
          // margin-left: 1.7rem;
          // padding-left: 1.7rem;
          position: relative;
          display: flex;
          height: 4rem;
          align-items: center;
          justify-content: flex-start;

          span {
            font-size: 20px;
            font-weight: 500;
            color: #a0a0a0;
            position: absolute;
            left: 1.6rem;
            bottom: -1.3rem;
          }
        }

        // .top::before {
        //   content: '';
        //   width: 1.3rem;
        //   height: 1.6rem;
        //   border-radius: 6px;
        //   background-color: #888888;
        //   position: absolute;
        //   top: 0.9rem;
        //   left: 0;
        // }
        // .top::after {
        //   content: '';
        //   width: 1.4rem;
        //   height: 1.2rem;
        //   border-radius: 5px;
        //   background-color: #212121;
        //   position: absolute;
        //   top: 1.08rem;
        //   left: 0.2rem;
        // }

        .cont {
          display: flex;
          align-items: center;
          text-align: left;
          // margin: 10px 0;
          color: #a0a0a0;
          font-size: 20px;


          p {
            line-height: 40px;
          }

          .iconBox {
            min-width: 25px;
            // max-width: 26px;
            // margin-right: 8px;

            img {
              width: 100%;
            }
          }
        }

        p {
          display: flex;
          align-items: center;
          text-align: left;
          margin: 10px 0;
          color: #a0a0a0;
          font-size: 20px;
          line-height: 40px;

          svg {
            min-width: 25px;
            margin-right: 8px;
          }
        }

        .iconBox {
          max-width: 25px;
          margin-right: 8px;

          img {
            width: 100%;
          }
        }

      }
    }

    .copyright {
      p {
        margin: 0;
        border-top: 1px solid #5a5a5a;
        padding: 1rem 0;
        color: #888;
        text-align: center;

        span {
          color: #888;
        }

        a:hover {
          color: #eee !important;
        }
      }
    }
  }
}



@media screen and (max-width: 768px) {
  .footerBarBox {
    .footerBarCont {
      padding: 30px 0 !important;
      flex-direction: column !important;

      .left {
        flex-direction: column !important;
        margin-right: 0 !important;

        .cont {
          display: flex;
          flex-wrap: wrap;

          .top {
            width: 100% !important;
            font-size: 16px !important;
            margin-bottom: 5px !important;
            padding-bottom: 5px !important;
            border-bottom: 1px solid #5a5a5a !important;
            margin-top: 10px;
            text-align: left;
            display: inline !important;
            height: inherit !important;
          }

          p {
            margin: 5px 0 !important;
            margin-right: 10px !important;
          }
        }
      }

      .right {
        max-width: 100% !important;
        border-left: none !important;
        padding-left: 0 !important;

        .top {
          // width: 100% !important;
          font-size: 16px !important;
          margin-bottom: 5px !important;
          padding-bottom: 0.6rem !important;
          border-bottom: 1px solid #5a5a5a !important;
          margin-top: 10px !important;
          text-align: left;

          span {
            font-size: 16px !important;
            left: 1.6rem !important;
            bottom: 0.6rem !important;
          }

          img {
            height: 25px;
          }
        }
      }


    }

    .copyright {
      background-color: #000;


      p {
        font-size: 1rem !important;
        // border-top: 0 !important;
      }
    }
  }

}
</style>